var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonAttendanceUpdateTimeModal',{attrs:{"attendance":_vm.attendance,"employee":_vm.employee,"hold":_vm.isBusy},on:{"onSubmitClick":_vm.updateAttendance}})}
var staticRenderFns = []

export { render, staticRenderFns }